<template>
  <div style="height: 100%">
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      <div>
        <el-form :inline="true" :model="searchForm" ref="searchForm" class="search-form" size="small">
          <el-form-item label="页面标题" prop="title">
            <el-input v-model="searchForm.title" placeholder="请输入页面标题"></el-input>
          </el-form-item>
          <el-form-item label="页面标签" prop="tagName">
            <el-input v-model="searchForm.tagName" placeholder="请输入页面标签"></el-input>
          </el-form-item>
          <el-form-item label="创建时间" prop="createdTimeStart">
            <el-date-picker v-model="value1" type="daterange" size="small" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fetchData('search')">查询</el-button>
            <el-button type="primary" plain @click="fetchData('reset')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <h3>列表数据</h3>
        <div>
          <el-button type="primary" @click="add('')">新增页面</el-button>
        </div>
      </div>
      <div id="base-list">
        <lb-table v-horizontal-scroll="'always'" :column="columns" :data="pageList" pagination :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="page.pageNo" :page-size="page.pageSize" @size-change="handleSizeChange"
          @p-current-change="handleCurrentChange">
        </lb-table>
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    breadcrumbTop,
    breadcrumbSearch,
    LbTable,
  },
  data() {
    return {
      title: '添加账号',
      isEdit: false,
      name: '',
      dataList: {
        list: [
          { title: 'APP设置', path: '', type: '0' },
          { title: '页面设置', path: '', type: '1' }
        ]
      },
      searchList: {
        list: [
          { title: '页面设置', path: '', type: '0' },
          { title: '数据筛选', path: '', type: '1' }
        ]
      },
      newForm: {
        name: '',
        password: '',
        confirmPassword: '',
        roleId: null
      },
      searchForm: {
        title: '', // 	
        createdTimeStart: '',
        createdTimeEnd: '',
        tagName: '',
        pageNo: 1,
        pageSize: 10
      },
      value1: [],
      brandList: [],
      columns: [
        { label: '排序', prop: 'pageOrder', minWidth: '220' },
        { label: '页面标题', prop: 'title', minWidth: '220' },
        { label: '绑定标签', prop: 'tagNames', minWidth: '220' },
        { label: '页面背景', prop: 'title', minWidth: '220',
          render: (h, scope) =>{
            let pp = scope.row.bgImg ? <img style="width:100px;height:100px;" src={scope.row.bgImg} /> : ''
            return (
              <div>
                {pp}
              </div>
            )
          }
        },
        { label: '页面背景颜色', prop: 'bgColor', minWidth: '220' },
        { label: '创建时间', prop: 'createdTime', minWidth: '100' },
        {
          label: '操作',
          minWidth: '120',
          fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.add(scope.row.id) }}>查看/编辑</span>
                <span style='color:#2D46EE;cursor:pointer;margin-left:12px' onClick={() => { this.delete(scope.row.id) }}>删除</span>
              </div >
            )
          }
        }],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      pageList: [],
      roleList: [],
      platformId: "",
      rowId: null
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getPageList();
    });
    // if (from.name == 'newPage') {
    //   next(vm => {
    //     vm.getPageList();
    //   });
    // } else {
    //   next(vm => {
    //     vm.getPageList();
    //   });
    // }
  },
  created() {
    // this.getPageList()
    let userInfo = sessionStorage.getItem('userInfo')
    this.platformId = JSON.parse(userInfo).platformId;
  },
  methods: {
    getPageList() {
      if(this.value1 && this.value1.length > 0){
        this.searchForm.createdTimeStart = this.value1[0]
        this.searchForm.createdTimeEnd = this.value1[1]
      }else{
        this.searchForm.createdTimeStart = ''
        this.searchForm.createdTimeEnd = ''
      }
      this.axios.post('/appIndex/pageList', this.searchForm)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.pageList = res.data.list;
            this.page.totalNum = res.data.totalNum;
          }
        })
    },
    getName(e) {
      console.log(e)
      this.newForm.name = e.replace(/[\u4e00-\u9fa5/\s+/]|[^a-zA-Z0-9\u4E00-\u9FA5]/g, "")
    },
    fetchData(type) {
      this.page.pageNo = 1
      this.searchForm.pageNo = 1;
      if (type == 'search') {

      } else {
        this.searchForm.title = '';
        this.searchForm.status = '';
        this.searchForm.tagName = '';
        this.searchForm.createdTimeEnd = '';
        this.searchForm.createdTimeStart = '';
        this.value1 = []
      }
      if (this.value1) {
        this.searchForm.createdTimeEnd = this.value1[1]
        this.searchForm.createdTimeStart = this.value1[0]
      } else {
        this.searchForm.createdTimeEnd = ''
        this.searchForm.createdTimeStart = ''
      }
      this.getPageList()
    },

    handleCurrentChange(e) {
      console.log(e)
      this.page.pageNo = e
      this.searchForm.pageNo = e;
      this.getPageList()
    },
    handleSizeChange(e) {
      this.page.pageSize = e
      this.searchForm.pageSize = e;
      this.getPageList()
    },

    add(id) {
      let platformType = sessionStorage.getItem('platformType') || 0
      let name = 'newPage'
      if (platformType == '1') {
        name = 'inflowNewPage'
      }

      this.$router.push({
        name: name,
        query: {
          id: id || ''
        }
      })
    },

    delete(id) {
      this.$confirm('是否确认删除？删除后不可恢复数据！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios.post('/appIndex/delete', { id: id })
          .then(res => {
            console.log(res)
            if (res.code == 0) {
              this.page.pageNo = 1;
              this.searchForm.pageNo = 1;
              this.getPageList()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }
          })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    }
  }
}
</script>
  
<style scoped lang="scss">
input[type="text"],
input[type="number"] {
  -webkit-appearance: none;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #d8dce5;
  box-sizing: border-box;
  color: #5a5e66;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 1;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 100%;

  &:hover {
    border-color: #b4bccc;
  }

  &:focus {
    border-color: #409EFF;
    outline: 0;
  }
}

::v-deep .el-input--prefix .el-input__inner {
  padding-left: 30%;
}

::v-deep .el-dialog__wrapper {
  text-align: center;
  white-space: nowrap;
  overflow: auto;

  &:after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    height: 100%;
  }

  .el-dialog {
    margin: 30px auto !important;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    white-space: normal;
  }
}

::v-deep .el-dialog__header {
  text-align: left;
  border-bottom: none;
}

.info {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 0px;
  color: #303033;
  opacity: 1;
  text-align: left;
}

.info-b {
  margin-left: 20px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 40px;
  color: #303033;
  text-align: left;
}

.info-q {
  width: 124px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  border: 1px solid #909099;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #909099;
  margin-right: 18px;
  cursor: pointer;
}

.info-s {
  width: 126px;
  height: 40px;
  line-height: 40px;
  background: #2d46ee;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

.title {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

#base-list {
  margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
  display: inline-block;

  a {
    margin: 0 5px;
  }
}

.search-form {
  // margin-top: 20px;
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    /deep/ .el-form-item__label {
      width: 78px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }

    /deep/ .el-form-item__content {
      display: block;
      margin-left: 78px;

      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}

/deep/ .el-table {
  color: #303033;
}
</style>
  
  